<div class="modal-header" style="display:flex;" ngbAutofocus>
    <h3 class="modal-title">Multiple Matches Found</h3>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-lg-6 col-md-8 col-8" style="margin-bottom:10px;">
            <label><strong>Match to Credit Card</strong></label>
            <ng-select [(ngModel)]="formData.selectedExpenseItem"
                       bindLabel="displayValue"
                       [searchable]="true"
                       [clearable]="false"
                       dropdownPosition="bottom">
                <ng-option *ngFor="let data of pendingList" [value]="data">{{data.displayValue}}</ng-option>
            </ng-select>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="creditCardAction()" [disabled]="formData.selectedExpenseItem == null">Match</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>